<ng-progress color="red" [thick]="true" [spinner]="false" [trickleSpeed]="500" [ease]="'easeInSine'" (started)="ngProgress.startedClass" (completed)="ngProgress.endedClass"></ng-progress>
<div id="azureReportingDashboard" class="subBlockContainer" *ngIf="!narrowMode">
  <div class="subBlockContent">
    <child-header [title]="title" (closeEvent)="close()" [showDownload]="true" titleDownload="Download Excel" (downloadEvent)="downloadReports()"></child-header>
    <div class="inner-subBlock-wrapper">
      <!-- <div class="page-title-wrapper">
        <div class="title blade-title">
          {{title}}
        </div>
        <i class="material-icons closebutton-pullfloat-right" (click)="close()">close</i>
      </div> -->

      <div id="basic-info-wrapper">
        <div style="margin-bottom: 20px;" class="row filter-wrapper">
          <div class="row filter-wrapper margin-l-x15 padding-b-x10">
            <div class="col searchInput-position">
              <div class="searchInputGroup">
                <div class="searchIcon">
                  <img src="../../images/new_ui/filter.png">
                </div>
                <input class="searchInput" type="text" placeholder="Filter" onfocus="this.placeholder=''"
                  onblur="this.placeholder='Filter'" [(ngModel)]="searchField" (ngModelChange)="onChange()">
              </div>
            </div>
            <div class="col col-large date-picker-margin">
              Date From:
              <div class="searchInputGroup">
                <div class="searchIcon" (click)="dateFrom.toggle()">
                  <img src="../../images/new_ui/date.png">
                </div>
                <input id="dateFrom" class="searchInput date-picker" type="text" [(ngModel)]="fromDate"
                  placeholder="Date" mame="datePicker" ngbDatepicker #dateFrom="ngbDatepicker"
                  (click)="dateFrom.toggle()">
              </div>
            </div>
            <div class="col col-large date-picker-margin">
              To:
              <div class="searchInputGroup">
                <div class="searchIcon" (click)="dateTo.toggle()">
                  <img src="../../images/new_ui/date.png">
                </div>
                <input id="dateTo" class="searchInput date-picker" type="text" [(ngModel)]="toDate" placeholder="Date"
                  mame="datePicker" ngbDatepicker #dateTo="ngbDatepicker" (click)="dateTo.toggle()">

              </div>
            </div>
            <div class="col col-small button-position">
              <button id="btnFilter" class="button button-red button-mid" (click)="filterReports();">Search</button>
            </div>
            <!-- <div class="col col-small">
              <div id="btnDownload" class="basic-icon download-icon download-icon-position" placement="top"
                ngbTooltip="Download Excel with licence keys" (click)="downloadReports()"></div>
            </div> -->
          </div>

        </div>
      </div>
      <div class="inner-subBlock-wrapper" *ngIf="!narrowMode && loadingFinished && perpetualList?.length > 0">
        <div class="page-subtitle-wrapper">ESD REPORT FROM {{ strDateFrom }} TO {{ strDateTo }}</div>
        <div class="shared-outer-wrapper table-header-allign">
          <table matSort (matSortChange)="sortData($event)">
            <thead>
              <tr class="row order-title-wrapper">
                <th class="col align-left" style="min-width:28%;" mat-sort-header="out_eu_name">END USER NAME</th>
                <th class="col align-left" style="min-width:18%;" mat-sort-header="out_cust_reference">CUSTOMER REF</th>
                <th class="col align-left" style="min-width:15%;" mat-sort-header="out_order_date">ORDER DATE</th>
                <th class="col align-left" style="min-width:12%;" mat-sort-header="out_order_no">ORDER NO</th>
                <th class="col align-center" style="min-width:6%;">QUANTITY</th>
                <th class="col align-right" style="min-width:15%;">TOTAL(ex GST)</th>
                <th style="min-width: 6%;"></th>
              </tr>
            </thead>
          </table>
        </div>
        <div class="shared-outer-wrapper child-body">
          <table matSort (matSortChange)="sortData($event)">
            <thead hidden="true">
              <tr class="row order-title-wrapper">
                <th class="col align-left" style="min-width:28%;" mat-sort-header="out_eu_name">END USER NAME</th>
                <th class="col align-left" style="min-width:18%;" mat-sort-header="out_cust_reference">CUSTOMER REF</th>
                <th class="col align-left" style="min-width:15%;" mat-sort-header="out_order_date">ORDER DATE</th>
                <th class="col align-left" style="min-width:12%;" mat-sort-header="out_order_no">ORDER NO</th>
                <th class="col align-center" style="min-width:6%;">QUANTITY</th>
                <th class="col align-right" style="min-width:15%;">TOTAL(ex GST)</th>
                <th style="min-width: 6%;"></th>
              </tr>
            </thead>
            <tbody class="scrollable-table-body">
              <ng-container *ngIf="sortedData && sortedData?.length > 0">
                <ng-container
                  *ngFor="let esd of sortedData | TableFilterMultiple:['out_eu_name', 'out_cust_reference', 'out_order_date','out_order_no'] : searchField">
                  <tr class="row">
                    <td class="col-md align-left" style="min-width:28%;">{{esd?.out_eu_name}}</td>
                    <td class="col-md align-left" style="min-width:18%;">{{esd?.out_cust_reference}}</td>
                    <td class="col-md align-left" style="min-width:15%;">{{esd?.out_order_date}}</td>
                    <td class="col-md align-left" style="min-width:12%;">{{esd?.out_order_no}}{{esd?.out_bo_suffix}}
                    </td>
                    <td class="col-md align-center" style="min-width:6%;">{{esd?.out_order_qty | number: '1.0-0'}}</td>
                    <td class="col-md align-right" style="min-width:15%;">
                      {{esd?.out_amount | currency:'AUD':'symbol-narrow':'.2-2'}}</td>
                    <td class="col-md align-left" style="min-width: 6%;padding-left: 10px;">
                      <button class="button button-red button-small"
                        [routerLink]="['detail', esd.out_order_no, esd.out_bo_suffix]">View</button>
                    </td>
                    <!-- <td class="col-md" style="maxl-width: 5%" >
                          <div id="downloadBtn{{esd?.out_order_date}}" class="basic-icon download-icon" placement="top" ngbTooltip="Download Excel" ></div>
                      </td> -->
                  </tr>
                </ng-container>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>

      <div class="inner-subBlock-wrapper" *ngIf="loadingFinished && perpetualList?.length < 1">
        <div class="noData-wrapper">
          <div>
            <img src="../../images/new_ui/no-subscription.png">
          </div>
          <label class="noData-label">
            WE COULDN'T FIND ANY DATA<br />
          </label>
          <br />

        </div>
      </div>

    </div>

    <loading-screen *ngIf="!loadContent" [showBlurTable]="true" (currentLoadingStatus)="onLoading($event)">
    </loading-screen>
  </div>
</div>
<div class="narrow-sidebar narrow-sidebar-height" id="levelTwo" *ngIf="narrowMode" style="margin-top:0; height: 100%;">
  <div class="child-sidebar">
    <child-header [title]="title" (closeEvent)="navigateTo('/reporting/esdreport')"></child-header>
    <!-- <div class="page-title-wrapper">
      <div class="title blade-title-font">
        {{title}}&nbsp;
      </div>
      <i class="material-icons closebutton-pullfloat-right" [routerLink]="['/reporting/esdreport']">close</i>
    </div> -->
    <div class="child-body child-body-narrowMode">
      <ng-container *ngFor="let esd of sortedData;let index = index">
        <div class="menu-wrapper" id="{{esd.out_order_no}}{{esd?.out_bo_suffix}}"
          [routerLink]="['detail', esd.out_order_no, esd.out_bo_suffix]" routerLinkActive="active"
          [class.active]="isActive(esd.out_order_no, esd.out_bo_suffix)">
          <div> {{esd?.out_eu_name}}</div>
          <div>Reference - {{esd?.out_cust_reference}} </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<router-outlet (activate)='onActivate($event)'></router-outlet>